var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { HotTable } from '@handsontable/react-wrapper';
import { Divider, TextField, Typography } from '@mui/material';
import { useLoaderData } from 'react-router-dom';
import HeaderCFTemplate from '@modules/cashflow/cf-template/components/HeaderCFTemplate';
import useCashFlowHandsonTableConfig from '@modules/cashflow/cf-template/hooks/useCashFlowHandsonTableConfig';
import useCRUDCashflowTemplateController from '@modules/cashflow/cf-template/controllers/crud-cf-template.controller';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var EditCfTempTemplate = function () {
    var _a;
    var cfTemplate = useLoaderData();
    var t = useCustomTranslation();
    var _b = useCRUDCashflowTemplateController(), hotRef = _b.hotRef, listBtns = _b.listBtns, amountIndex = _b.amountIndex, titleInputRef = _b.titleInputRef, requiredColumns = _b.requiredColumns, handleCheckRequiredColumns = _b.handleCheckRequiredColumns, handleCheckRequiredColumnsState = _b.handleCheckRequiredColumnsState, handleCheckRequiredColumnsAfterDrop = _b.handleCheckRequiredColumnsAfterDrop;
    var _c = useCashFlowHandsonTableConfig({
        handleCheckRequiredColumnsAfterDrop: handleCheckRequiredColumnsAfterDrop
    }), colWidths = _c.colWidths, contextMenu = _c.contextMenu, cellValidator = _c.cellValidator, generateMergeCells = _c.generateMergeCells;
    var _d = generateMergeCells(((_a = cfTemplate === null || cfTemplate === void 0 ? void 0 : cfTemplate.CashflowContent) === null || _a === void 0 ? void 0 : _a.content) || []), mergeCells = _d.mergeCells, highlightedRows = _d.highlightedRows;
    var content = useMemo(function () {
        if (!cfTemplate)
            return [];
        return cfTemplate.CashflowContent.content;
    }, [cfTemplate]);
    useEffect(function () {
        if (!cfTemplate)
            return;
        handleCheckRequiredColumnsState(cfTemplate.CashflowContent.required.split('').reduce(function (acc, cur, idx) {
            var _a;
            return __assign(__assign({}, acc), (_a = {}, _a[idx] = cur === '1', _a));
        }, {}));
    }, [cfTemplate]);
    var cells = function (row, col) {
        var cellProperties = {};
        if (row !== 0 || col < 3) {
            cellProperties.editor = false;
        }
        else {
            cellProperties.validator = cellValidator;
            cellProperties.allowInvalid = true;
            // cellProperties.manualColumnMove = true
        }
        if (highlightedRows.has(row) && col >= 1) {
            cellProperties.className = 'parent-row';
        }
        return cellProperties;
    };
    return (_jsxs("div", { className: 'table_handsome ht-theme-main flex flex-col gap-2 overflow-y-auto p-8', children: [_jsx(HeaderCFTemplate, { title: t('L000111'), listBtns: listBtns }), _jsxs("div", { className: 'flex-1 flex flex-col gap-2 pb-3 bg-white rounded-lg', children: [_jsxs("div", { className: 'flex w-full px-4 py-2 items-center gap-3', children: [_jsx(Typography, { children: t('L000027') }), _jsx(TextField, { defaultValue: cfTemplate.name || '', inputRef: titleInputRef, required: true, variant: 'standard', sx: {
                                    width: 200
                                } })] }), _jsx(Divider, { sx: {
                            height: 2
                        } }), _jsx(Typography, { variant: 'h5', sx: {
                            px: 2
                        }, children: "Content Frame" }), _jsx("div", { className: 'px-4 flex-1', children: _jsx(HotTable, { ref: hotRef, width: '100%', height: '100%', data: content, contextMenu: contextMenu('create'), cells: cells, comments: true, colWidths: colWidths, selectionMode: 'single', mergeCells: mergeCells, afterChange: function (changes, source) {
                                if (source === 'edit') {
                                    var hotInstance_1 = hotRef.current.hotInstance;
                                    changes.forEach(function (_a) {
                                        var row = _a[0], col = _a[1];
                                        hotInstance_1.setCellMeta(row, Number(col), 'comment', null);
                                    });
                                    hotInstance_1.render();
                                }
                            }, colHeaders: function (col) {
                                var defaultColumns = ['Seq. Col', 'Item Column', 'Department'];
                                var title = defaultColumns[col] || "Required";
                                if (col === amountIndex) {
                                    return '<span>Amt. Column</span>';
                                }
                                if (col < defaultColumns.length) {
                                    return "<span>".concat(title, "</span>");
                                }
                                return "\n              <div style=\"display: flex; justify-content: space-between; align-items: center; gap: 5px; cursor: pointer\">\n              <input type=\"checkbox\" ".concat(requiredColumns[col] ? 'checked' : '', " data-col=\"").concat(col, "\" />\n              <span>").concat(title, "</span>\n              </div>\n              ");
                            }, afterGetColHeader: function (col, TH) {
                                var checkbox = TH.querySelector("input[type=\"checkbox\"][data-col=\"".concat(col, "\"]"));
                                if (checkbox) {
                                    checkbox.addEventListener('change', function (e) {
                                        handleCheckRequiredColumns(e, col);
                                    });
                                }
                            }, licenseKey: 'non-commercial-and-evaluation' }) })] })] }));
};
export default EditCfTempTemplate;
